var map = {
	"./photo1.png": 8210,
	"./photo10.png": 3704,
	"./photo11.png": 3921,
	"./photo12.png": 2810,
	"./photo13.png": 563,
	"./photo2.png": 8921,
	"./photo3.png": 7744,
	"./photo4.png": 9071,
	"./photo5.png": 2742,
	"./photo6.png": 4365,
	"./photo7.png": 4420,
	"./photo8.png": 2083,
	"./photo9.png": 858
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2950;